import { Component } from '@angular/core';

interface ShowcaseProject {
    name: string;
    url?: string;
    image?: string;
}

interface ShowcaseGroup {
    title: string;
    intro: string;
    projects: ShowcaseProject[];
}

@Component({
    selector: 'app-portafolio',
    templateUrl: './portafolio.component.html',
    styleUrls: ['./portafolio.component.scss'],
    standalone: false
})
export class PortafolioComponent {

    // Projects without a url/image are shown as "Coming soon".
    groups: ShowcaseGroup[] = [
        {
            title: 'Branding Websites & Online Stores',
            intro: 'Websites and e-commerce stores we have designed and built for our clients.',
            projects: [
                { name: 'Sydney Flooring Solutions', url: 'https://www.sydneyflooringsolutions.com.au/index.html', image: 'assets/img/blog-image/sydney floring.PNG' },
                { name: 'Prime Luck International Pvt', url: 'https://www.primeluck.international/', image: 'assets/img/blog-image/PrimeLuck_homepage.png' },
                { name: 'Katlas Holdings', url: 'https://www.katlas.holdings/', image: 'assets/img/blog-image/katalas_homepage.png' },
                { name: 'Wimaladharma & Sons', url: 'https://wimaladharmaandsons.lk/', image: 'assets/img/blog-image/wimaladarma and sons.PNG' },
                { name: 'Real Life', url: 'https://real-life-store.vercel.app/', image: 'assets/img/blog-image/RealLife_homepage.png' },
                { name: 'Temphurs Pvt Ltd', url: 'https://www.temphurs.com/home/one', image: 'assets/img/blog-image/Temphurs_homepage.png' },
                { name: 'Dark Sky Innovation', url: 'https://www.darkskyinnovations.xyz/home', image: 'assets/img/blog-image/dark sky innovation.PNG' },
                { name: 'Cameco Trading\'s' },
                { name: 'Nerox' }
            ]
        },
        {
            title: 'Mission Critical Web Applications',
            intro: 'Platforms currently in development — check back soon.',
            projects: [
                { name: 'Jobsy' },
                { name: 'Islanders Network' },
                { name: 'Travelion' }
            ]
        }
    ];

}
